<ngx-loading [show]="loading" [template]="customLoadingTemplate"></ngx-loading>
<ng-template #customLoadingTemplate>
  <h3>{{loadingMessage}}</h3>
</ng-template>

<div *ngIf="!showTasksStep">

  <div class="modal-header">
    <h3 class="d-block text-center w-100" id="modal-basic-title">
      Please pick the {{isRCDSS ? 'Contracts':'Purchase Orders'}} to apply the workflow: {{workflow.name}}
    </h3>
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col-md-12">
        <dx-data-grid
          [rowAlternationEnabled]="true"
          [hoverStateEnabled]="true"
          [cellHintEnabled]="false"
          [columnAutoWidth]="true"
          [dataSource]="contracts"
        >

          <dxo-sorting mode="single"></dxo-sorting>
          <dxo-search-panel [visible]="true"></dxo-search-panel>
          <dxo-header-filter [visible]="true"></dxo-header-filter>

          <dxi-column caption="Apply" [width]="100" dataField="" cellTemplate="checks"></dxi-column>

          <dxi-column
            [minWidth]="130"
            width="auto"
            [caption]="isRCDSS ? 'Contract #':'Purchase Order #'"
            dataField="customer_po_number"
            [allowSorting]="true">
          </dxi-column>
          <dxi-column *ngIf="isRCDSS" dataField="rcdss_contract_program" caption="Program" [minWidth]="120" width="auto"></dxi-column>
          <dxi-column dataField="supplier_name" caption="{{ isRCDSS ? 'Vendor' : 'Supplier' }}" [minWidth]="120"></dxi-column>

          <div class="text-center" *dxTemplate="let item of 'checks'">
            <mat-checkbox
              (change)="setForAppliance($event, item.data)"
              [disabled]="item.data?.is_workflow_applied"
              [checked]="false"></mat-checkbox>
          </div>

          <dxo-paging [pageSize]="12"></dxo-paging>
        </dx-data-grid>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12">
        <div class="alert alert-info">
          <strong>Note:</strong> You will not be able to select a contract that already has a workflow assigned.
        </div>
      </div>
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="closeModal()">Cancel</button>
    <button class="btn btn-primary" (click)="next()" [disabled]="!resourcesToApply.length">{{tasksPendingResponsible.length > 0 ? 'Next' : 'Apply'}}</button>
  </div>

</div>

<div *ngIf="showTasksStep">

  <div class="modal-header">
    <h3 class="d-block text-center w-100" id="modal-basic-title">
      Please pick the missing responsibles for the tasks about to be inserted to each {{isRCDSS ? 'Contract':'Purchase Order'}}.
    </h3>
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col-md-12">
        <dx-tree-list
          [rowAlternationEnabled]="true"
          [hoverStateEnabled]="true"
          [cellHintEnabled]="false"
          [columnAutoWidth]="true"
          [dataSource]="resourcesToApply"
          itemsExpr="tasks_pending_responsible"
          dataStructure="tree"
          [autoExpandAll]="true"
        >

          <dxi-column
            [minWidth]="130"
            width="auto"
            [caption]="isRCDSS ? 'Contract #':'Purchase Order #'"
            dataField="doc_number"
            [allowSorting]="true">
          </dxi-column>
          <dxi-column *ngIf="isRCDSS" dataField="rcdss_contract_program" caption="Program" [minWidth]="120" width="auto"></dxi-column>
          <dxi-column dataField="supplier_name" caption="{{ isRCDSS ? 'Vendor' : 'Supplier' }}" [minWidth]="120"></dxi-column>
          <dxi-column dataField="task_name" caption="Task" [minWidth]="120"></dxi-column>
          <dxi-column caption="Responsible" [minWidth]="120" cellTemplate="ctResponsibles"></dxi-column>

          <div *dxTemplate="let data of 'ctResponsibles'">
            <mat-form-field *ngIf="data.data.task_id">
              <mat-select placeholder="Responsible" (selectionChange)="setResponsible($event, data.data)">
                <mat-option [value]="null">None (set automatically to primary contact)</mat-option>
                <mat-option *ngFor="let user of getRelevantUsers(data.data.task_id)" [value]="user.id">
                  {{ user.first_name }} {{ user.last_name }} ({{user.company.name}})
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

        </dx-tree-list>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12">
        <div class="alert alert-warning">
          <strong>Note:</strong> All tasks left without an assigned responsible will be automatically assigned the primary contact of the company meant to complete the task.
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="closeModal()">Cancel</button>
    <button type="button" class="btn btn-secondary" (click)="back()">Back</button>
    <button class="btn btn-primary" (click)="save()">Apply</button>
  </div>

</div>
